import { checkoutOptimizationStepArraySchema } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateProspectiveCheckoutTree = {
  name: "updateProspectiveCheckoutTree" as const,
  input: z.object({
    splitId: zExt.objectId(),
    checkoutTreeFlowSteps: checkoutOptimizationStepArraySchema,
  }),
  output: z.null(),
};
